import { render, staticRenderFns } from "./Goodsdetail.vue?vue&type=template&id=47ca5a36&"
import script from "./Goodsdetail.vue?vue&type=script&lang=js&"
export * from "./Goodsdetail.vue?vue&type=script&lang=js&"
import style0 from "./Goodsdetail.vue?vue&type=style&index=0&id=47ca5a36&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47ca5a36')) {
      api.createRecord('47ca5a36', component.options)
    } else {
      api.reload('47ca5a36', component.options)
    }
    module.hot.accept("./Goodsdetail.vue?vue&type=template&id=47ca5a36&", function () {
      api.rerender('47ca5a36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Goodsdetail.vue"
export default component.exports